import {change, resetSection} from "redux-form";


const DEALERS_URL = process.env.REACT_APP_VPC_DEALERS_API_URL;

export function transformVehicle(vehicle = ""){
    const np = [];
    decodeURIComponent(vehicle.toLowerCase().trim()).split(/[-\s]/).forEach(function(p){
        np.push(p.replace( /\D/ , function(a){ return a.toUpperCase()}))
    }); //?
    let vehicle_name = np.join(" ");
    if(vehicle_name == "Compass E"){
        vehicle_name = "Compass e";
    }
    return vehicle_name;
}

export const POSTCODE_REGEX = /^(0[289][0-9]{2})|([1345689][0-9]{3})|(2[0-8][0-9]{2})|(290[0-9])|(291[0-4])|(7[0-4][0-9]{2})|(7[8-9][0-9]{2})$/;

async function postcode(values, errors , division ){
    try{
        const response = await LookupDealerByPostCodeAndDivision({postcode: values.postcode , division :division});
        if (!values.postcode || !response.success) {
            errors.postcode = "Please specify valid postcode";
        }
    }
    catch(err){
        errors.postcode = "Please specify valid postcode"
    }

}

function firstname(values,errors){
    if (!values.firstname || values.firstname.trim().length === 0) {
        errors.firstname = "Your first name is required";
    }else if(/[^A-Za-z0-9 \-()]/.test(values.firstname)) {
        errors.firstname = "Please enter a valid first name.";
    }
}

function lastname(values,errors){
    if (!values.lastname || values.lastname.trim().length === 0) {
        errors.lastname = "Your last name is required.";
    }else if(/[^A-Za-z0-9 \-()]/.test(values.lastname)) {
        errors.lastname = "Please enter a valid last name.";
    }
}

function email(values,errors){
    if(!values.email || values.email.trim().length === 0 ){
        errors.email = "Your email address is required."
    }
    else if (!/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(values.email.trim())) {
        errors.email = "Please enter a valid email address. (e.g. yourname@example.com)";
    }
}

function phone(values,errors){
    if(!values.phone || values.phone.trim().length === 0 ){
        errors.phone = "Your phone number is required."
    }
    else if (!values.phone || !/^\({0,1}((0|\+61)(2|4|3|7|8)){0,1}\){0,1}(\ |-){0,1}[0-9]{2}(\ |-){0,1}[0-9]{2}(\ |-){0,1}[0-9]{1}(\ |-){0,1}[0-9]{3}$/.test(values.phone.trim())) {
        errors.phone = "Please enter a valid Australian phone number.";
    }
}

function postcode1(values,errors){
    if(!/^[0-9]{4}$/.test(values.postcode)){
        errors.postcode = "Invalid postcode"
    }
}

function privacy(values,errors){
    if(!values['privacy']){
        errors['privacy'] = "Please tick accept "
    }
}

function model(values,errors){
    if (!values.vehicle || values.vehicle.trim().length === 0) {
        errors.vehicle = "please select a model";
    }
}


function BaseDetails(values){
    const errors = {};
    firstname(values,errors);
    lastname(values,errors);
    email(values,errors);
    phone(values,errors);
    return errors;
}

function WFFHDetails(values){
    const errors = {};
    firstname(values,errors);
    lastname(values,errors);
    email(values,errors);
    phone(values,errors);
    if(!/^[0-9]{4}$/.test(values.postcode)){
        errors.postcode = "Postcode is required"
    }
    return errors;
}

export function RYIValidator(values){
    const errors = BaseDetails(values);
    
    // Add postcode validation specifically for RYIValidator
    if (values.postcode) {
        // Normalize to 4 digits first
        const normalizedPostcode = parseInt(values.postcode, 10).toString().padStart(4, '0');
        
        // Validate against Australian postcode ranges
        const POSTCODE_REGEX = /^(0[289]\d{2}|1\d{3}|2[0-8]\d{2}|290\d|291[0-4]|3\d{3}|4\d{3}|5\d{3}|6\d{3}|7[0-4]\d{2}|7[8-9]\d{2}|8\d{3}|9\d{3})$/;
        
        if (!POSTCODE_REGEX.test(normalizedPostcode)) {
            errors.postcode = "Please specify valid postcode";
        }
    }
    
    return errors;
}

export function WFFHValidator(values){
    const errors = WFFHDetails(values);
    const valid_video_size = (size, maxsize = 50.000) => {
        return ((size / 1024) / 1024) <= maxsize;
    }
    if(values.video && !valid_video_size(values.video.size)){
        errors.video = "Invalid video size max size 50MB"
    }
    if(!values.occupation || (values.occupation && values.occupation.length === 0)){
        errors.occupation = "Your occupation is required.";
    }
    if(!values.answer || (values.answer && values.answer.length === 0)){
        errors.answer = "Please give an answer";
    }
    if(values.owner){
        if(!values.vehicleregistration || (values.vehicleregistration && values.vehicleregistration.length === 0)){
            errors.vehicleregistration = "Your vehicle registration is required.";
        }
    }

    return errors;
}

export function RABValidator(values){
    const errors = BaseDetails(values);
    return errors;
}

export function RAQValidator(values){
    const errors = BaseDetails(values);
    return errors;
}

export function RATDValidator(values){
    const errors = BaseDetails(values);
    if (!values.testdrivetiming || values.testdrivetiming.trim().length === 0) {
        errors.testdrivetiming = "please select an appointment time";
    }
    return errors;
}

export function RAVDValidator(values){
    const errors = BaseDetails(values);
    if (!values.testdrivetiming || values.testdrivetiming.trim().length === 0) {
        errors.testdrivetiming = "please select an appointment time";
    }
    return errors;
}

export function ContactUsValidator(values){
    const errors = BaseDetails(values);
    if (!values.owner || values.owner.trim().length === 0) {
        errors.owner = "please select if you own the vehicle";
    }
    return errors;
}

export default function (values, validator = (values) => {
    return {}
}) {
    return new Promise((resolve, reject) => {
        const sleep = ms => new Promise(resolve => setTimeout(resolve, ms));
        sleep(2000).then(() => {
            const errors = validator(values);
            if (Object.keys(errors).length > 0) {
                reject(errors);
            } else {
                resolve({});
            }
        });
    });
}

async function LookupDealerByPostCodeAndDivision({ postcode, division}) {
    if(/^[0-9]{4}$/.test(postcode)){
        try{
            const response = await fetch(`${DEALERS_URL}?postcode=${postcode}&division=${division}&department=sales`);
            if (response && response.ok) {
                const json = await response.json();
                return Object.assign({}, json.dealers[0], {success: true});
            } else {
                return {success: false};
            }
        }
        catch(err){
            //Returned true even if Redhat API times out
            return Object.assign({}, {}, {success: true});
            //return {success: false};
        }
    }
    else{
        return { success : false };
    }
}

async function LookupVirtualDemoDealerByPostCodeAndDivision({ postcode, division}) {
    if(/^[0-9]{4}$/.test(postcode)){
        try{
            const response = await fetch(`${DEALERS_URL}?postcode=${postcode}&division=${division}&department=sales&virtualdemo=true`);
            if (response && response.ok) {
                const json = await response.json();
                return Object.assign({}, json.dealers[0], {success: true});
            } else {
                return {success: false};
            }
        }
        catch(err){
            return {success: false};
        }
    }
    else{
        return { success : false };
    }
}

export function validateDealerForVirtualTestDrive(values,dispatch,props, blurredField){
    if("postcode" === blurredField){
        const { postcode , brand} = values;
        const { formName } = props;
        dispatch(resetSection(formName, 'dealer', 'dealerfound'));
        if(/^[0-9]{4}$/.test(values.postcode)){
            dispatch(change(formName, 'loaddealer', true));

            return new Promise(async (resolve, reject) => {
                const response = await LookupVirtualDemoDealerByPostCodeAndDivision({postcode , division: brand.division});
                dispatch(change(formName, 'loaddealer', false));
                if(response.success){
                    dispatch(change(formName, 'dealer', response));
                    dispatch(change(formName, 'dealerfound', response.success));
                    resolve();
                }
                else{
                    dispatch(change(formName, 'dealerfound', false));
                    reject({postcode : 'Please specify valid postcode'});
                }

            });
        }
        else{
            dispatch(change(formName, 'dealerfound', false));
            return Promise.reject({ postcode : "Please specify valid postcode"});
        }
    }
    return Promise.resolve();
}

export function validatePostcode(values, dispatch , props , blurredField) {
    if("postcode" === blurredField){
        const { brand , postcode } = values;
        const { formName } = props;
        dispatch(resetSection(formName, 'dealer', 'dealerfound'));
        if(/^[0-9]{4}$/.test(values.postcode)){
            dispatch(change(formName, 'loaddealer', true));
            return new Promise((resolve, reject) => {
                LookupDealerByPostCodeAndDivision({postcode , division : brand.division})
                    .then((response) => {
                        dispatch(change(formName, 'loaddealer', false));
                        if(response.success){
                            dispatch(change(formName, 'dealer', response));
                            dispatch(change(formName, 'dealerfound', response.success));
                            resolve();
                        }
                        else{
                            dispatch(change(formName, 'dealerfound', false));
                            reject({postcode : 'Please specify valid postcode'});
                        }
                    });
            });
        }
        else{
            dispatch(change(formName, 'dealerfound', false));
            return Promise.reject({ postcode : "Please specify valid postcode"});
        }
    }

    return Promise.resolve();
}

export function CompetitionValidator(values){
    const errors = BaseDetails(values);
    postcode1(values,errors);
    return errors;
}
